/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedTaxPrmRequestDto } from '../../models/backend-patched-tax-prm-request-dto';
import { BackendTaxPrmDto } from '../../models/backend-tax-prm-dto';

export interface ProjectTaxesTaxPrmsPartialUpdate$Params {
  /**
   * A unique integer value identifying this Моделирование налогов.
   */
  id: number;
  body?: BackendPatchedTaxPrmRequestDto;
}

export function projectTaxesTaxPrmsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxPrmsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendTaxPrmDto>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxPrmsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendTaxPrmDto>;
    }),
  );
}

projectTaxesTaxPrmsPartialUpdate.PATH = '/api/project_taxes/tax_prms/{id}/';
